module.exports = __webpack_public_path__ + "img/filup.70c79198.svg";